import { PostManualUpload } from "services/apiService";
import { RESET_UPLOAD_PURCHASE_ORDER,UPLOAD_PURCHASE_ORDER_ERROR, UPLOAD_PURCHASE_ORDER_SUCCESS, UPLOAD_PURCHASE_ORDER_REQUEST } from "./action-type";
import { SOMS_API_KEY, UPLOAD_MANUAL_PURCHASE_ORDER_ENDPOINT } from "services/CONSTANTS";

export const uploadManualPoFile = (payload) => {
    const { params } = payload;
    const apiEndPointUrl = `${UPLOAD_MANUAL_PURCHASE_ORDER_ENDPOINT}?apikey=${SOMS_API_KEY}`
    return (dispatch) => {
        dispatch(uploadPurchaseOrderRequest());
        PostManualUpload(apiEndPointUrl, params)
            .then((response) => {
                if (response.status === 200)
                    dispatch(uploadPurchaseOrderSuccess(response));
                else
                    dispatch(uploadPurchaseOrderError(response));
            })
            .catch((err) => {
               
                dispatch(uploadPurchaseOrderError(err.response));
            });

    };
};

export const uploadPurchaseOrderSuccess = (response) => {
    return {
        type: UPLOAD_PURCHASE_ORDER_SUCCESS,
        uploadPurchaseOrderResponse: response.data,
        isuploadPurchaseOrderError: false,
        isuploadPurchaseOrderSuccess: true,
        errorDetails:{}
    }
};


export const uploadPurchaseOrderRequest = () => {
    return {
        type: UPLOAD_PURCHASE_ORDER_REQUEST
    }
};

export const uploadPurchaseOrderError = (error) => {

    return {
        type: UPLOAD_PURCHASE_ORDER_ERROR,
        uploadPurchaseOrderResponse: error,
        isuploadPurchaseOrderError: true,
        isuploadPurchaseOrderSuccess: false,
        errorDetails:error
    }
};


export const resetUploadPurchaseOrder = () => { 
    return { 
        type: RESET_UPLOAD_PURCHASE_ORDER 
    };
 };



